const MISSION_CONTROL_KEY = 'missionControls';

interface MissionControlStorage {
    email: string;
    selectedMissionControlId: number;
    currentLoggedId?: string;
    [key: string]: any; // To allow dynamic keys for each email
}

const updateMissionControlLocalStorage = ({
    email,
    selectedMissionControlId,
    currentLoggedId,
}: {
    email: string;
    selectedMissionControlId: number;
    currentLoggedId?: string | number;
}): void => {
    const prevData = localStorage.getItem(MISSION_CONTROL_KEY);
    const prevDataJson = prevData ? (JSON.parse(prevData) as MissionControlStorage) : {};

    localStorage.setItem(
        MISSION_CONTROL_KEY,
        JSON.stringify({
            ...prevDataJson,
            email: email,
            currentLoggedId: currentLoggedId,
            selectedMissionControlId: selectedMissionControlId,
            [email]: selectedMissionControlId,
        }),
    );
};

const getMissionControlDataLocalStorage = (): MissionControlStorage | null => {
    const data = localStorage.getItem(MISSION_CONTROL_KEY);
    if (data) {
        const parsedData = JSON.parse(data) as MissionControlStorage;
        return parsedData || null;
    }
    return null;
};

const getMissionControlName = (name: string): string => `${name} M.C.`;

export {getMissionControlDataLocalStorage, getMissionControlName, updateMissionControlLocalStorage};
